import React, { useEffect, useState } from 'react';
import { AlertTriangle, WifiOff } from 'lucide-react';

const GlobalConnectionBanner: React.FC = () => {
  const [message, setMessage] = useState<string | null>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const showMessage = (text: string) => {
      setMessage(text);
      setVisible(true);
    };

    const handleOffline = () => {
      showMessage('Votre connexion internet est indisponible. Certaines données peuvent ne pas s’afficher.');
    };

    const handleOnline = () => {
      setMessage('Connexion rétablie. Les données vont se recharger progressivement.');
      setVisible(true);
      window.setTimeout(() => {
        setVisible(false);
      }, 4000);
    };

    const handleConnectivityIssue = (event: Event) => {
      const customEvent = event as CustomEvent<{ message?: string }>;
      showMessage(
        customEvent.detail?.message ||
          'Connexion internet instable. Certaines données peuvent être temporairement indisponibles.'
      );
    };

    if (typeof navigator !== 'undefined' && navigator.onLine === false) {
      handleOffline();
    }

    window.addEventListener('offline', handleOffline);
    window.addEventListener('online', handleOnline);
    window.addEventListener('api:connectivity-issue', handleConnectivityIssue as EventListener);

    return () => {
      window.removeEventListener('offline', handleOffline);
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('api:connectivity-issue', handleConnectivityIssue as EventListener);
    };
  }, []);

  if (!visible || !message) return null;

  const offline = typeof navigator !== 'undefined' && navigator.onLine === false;

  return (
    <div className="fixed top-0 inset-x-0 z-[200] px-3 py-2">
      <div className={`mx-auto max-w-6xl rounded-lg border px-4 py-3 shadow ${offline ? 'bg-red-50 border-red-300' : 'bg-amber-50 border-amber-300'}`}>
        <div className="flex items-start gap-2">
          {offline ? (
            <WifiOff className="h-5 w-5 text-red-700 mt-0.5 flex-shrink-0" />
          ) : (
            <AlertTriangle className="h-5 w-5 text-amber-700 mt-0.5 flex-shrink-0" />
          )}
          <p className={`text-sm ${offline ? 'text-red-900' : 'text-amber-900'}`}>{message}</p>
        </div>
      </div>
    </div>
  );
};

export default GlobalConnectionBanner;
